<template>
    <div>
        <dropper :index="index" :level="2"></dropper>
        <div  v-if="$parent.editMode"  class="delete is-pulled-right" @click="remove"></div>
        <div class="columns top10" style="margin-bottom: 10px">
            <div class="column has-text-centered">
                <div  class="google-ad" :id="`banner-ad-${index}-${rand1}`"></div>
            </div>
            <div class="column has-text-centered">
                <div  class="google-ad" :id="`banner-ad-${index}-${rand2}`"></div>
            </div>
            <div class="column has-text-centered">
                <div  class="google-ad" :id="`banner-ad-${index}-${rand3}`"></div>
            </div>
        </div>
       
    </div>
</template>


<script>
import colDrop from './colDrop.vue'
import dropper from './sectionDropper.vue'

export default{
    props: {index: Number},
    components: {dropper, colDrop},
    data: function(){
        return {
            rand1: az.getRandomInt(99999999999),
            rand2: az.getRandomInt(99999999999),
            rand3: az.getRandomInt(99999999999)
        }
    },
    mounted: function(){
        var self = this

        googletag.cmd.push(() => {
            // Define an ad slot for div with id "banner-ad".
            googletag
                    .defineSlot("/6355419/Travel/Europe/France/Paris", [300, 250], "banner-ad-" + self.index + "-" + self.rand1)
                    .addService(googletag.pubads());
            googletag
                    .defineSlot("/6355419/Travel/Europe/France/Paris", [300, 250], "banner-ad-" + self.index + "-" + self.rand2)
                    .addService(googletag.pubads());
            googletag
                    .defineSlot("/6355419/Travel/Europe/France/Paris", [300, 250], "banner-ad-" + self.index + "-" + self.rand3)
                    .addService(googletag.pubads());

            // Enable the PubAdsService.
            googletag.enableServices();
        });

        setTimeout(function(){
            googletag.cmd.push(() => {
                    // Request and render an ad for the "banner-ad" slot.
                    window.googletag.display("banner-ad-" + self.index + "-" + self.rand1)
                    window.googletag.display("banner-ad-" + self.index + "-" + self.rand2)
                    window.googletag.display("banner-ad-" + self.index + "-" + self.rand3)
            });

        }, 10)
    },

    methods: {
        remove: function(){
            this.$parent.removeSection(this.index)
        },

        beforeDestroy: function(){

            window.googletag.destroySlots();
            /*  var self = this;

            googletag.cmd.push(() => {
                // Define an ad slot for div with id "banner-ad".
                window.googletag.pubads().refresh()
            }) */
        },
    }
}


</script>